import { AgentStatus } from '../../types';

interface AgentAvatarProps {
  avatar: string;
  status: AgentStatus;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeConfig: Record<NonNullable<AgentAvatarProps['size']>, string> = {
  xs: 'w-6 h-6',
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-14 h-14',
  xl: 'w-20 h-20',
};

export function AgentAvatar({ avatar, status, size = 'md', className = '' }: AgentAvatarProps) {
  const wrapper = sizeConfig[size];
  const isDead = status === 'dead';

  return (
    <img
      src={avatar}
      alt=""
      className={`${wrapper} rounded-full object-cover flex-shrink-0 ${isDead ? 'grayscale opacity-60' : ''} ${className}`}
    />
  );
}
